import {UnlinkIcon} from '@primer/octicons-react'
import {useMemo} from 'react'

import type {DraftOrExistingIssue} from '../../content-preview-types'
import type {TreeNode} from '../use-draft-issue-tree-map'
import {RelationshipList} from './RelationshipList'
import {useRemoveDependencyCallback} from './use-remove-dependency-callback'

export function BlockingList({issueNode}: {issueNode: TreeNode<DraftOrExistingIssue>}) {
  const onRemoveDependency = useRemoveDependencyCallback()

  const title = useMemo(() => {
    if (issueNode.item.type === 'existing-issue') {
      // "Newly" indicates that we're adding to what already exists
      return 'Newly blocking'
    }
    return 'Is blocking'
  }, [issueNode])

  return (
    <RelationshipList
      title={title}
      items={issueNode.isBlocking.map(node => ({item: node.item}))}
      totalCount={issueNode.isBlocking.length}
      actions={[
        {
          key: 'unlink',
          label: 'Remove dependency',
          icon: <UnlinkIcon />,
          onSelect: relatedItem => {
            void onRemoveDependency(relatedItem, issueNode.item)
          },
        },
      ]}
    />
  )
}
